import { Component } from '@angular/core';
import { membersuiteLegacyProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Legacy Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitelegacyproduct-form',
    templateUrl: './membersuitelegacyproduct.form.component.html'
})
export class membersuiteLegacyProductFormComponent extends BaseFormComponent {
    public record!: membersuiteLegacyProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

